let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("humN1")).then(() => parcelRequire('7l6f4'));